import React, { useState, useContext, useEffect } from "react";

import { userAvatars, getUserAvatars, subscriptionStatuses } from "../../data";
import { users } from "../../data/users";

// import "../PAlauncher.css";
import styled, { css } from "styled-components";
import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  FormFooter,
  Button,
  Head,
  Card,
  Pagination,
  Input,
  RadioGroup,
  Switch,
  Icon,
  DatePickerInput,
  ButtonAction,
  ContentBlock,
  Tag,
  Notification
} from "xsolla-uikit";

import CardNew from "../PAcardNew";
import PAmodal from "../PApop";

import {
  PAchart1,
  PAchart2fake,
  PAchartMap
} from "../PAcharts";
import {
  PAlogin0fake,
  PAloginSocialfake,

  PAchart1fake,
  PAchart2
} from "../PAchart2";



import { PAusersSubsTable } from "./PAusersSubsTable";


import {
  PAconnectorInv,
  PAconnectorZapier,
  PAconnectorMCH
} from "../PAconnectors";
import PAtabs from "../PAtabs";
import PAh2 from "../PAh2";

import {
  ButtonSquare,
  PAinfoCollapsible,
  CssClick,
  CssLineHover,
  CssSelectStatus,
  CssTh,
  CssThTd,
  CssThFilt0,
  CssCounter
} from '../uikit2';

export default function PAusersSubscribers({
  history
 }) {
  const [pop, setPop] = useState(false);

  return (
    <FormGroup indentation="xs">
      {/* {pop !== false && (
        <PAusersSubsPop
          index={pop}
          handleModal={() => {
            setPop(false);
          }}
        />
      )} */}

      <FormGroup indentation="xs">
        <PAtableFilter />
      </FormGroup>

      <PAusersSubsTable
        type="subscribers"
        handleClick={id => {
          history.history.push(`/support/subscribers/${id}`)
          // setPop(id);
        }}
      />

      <FormGroup indentation="lg">
        <div style={{display: 'flex', justifyContent: 'center',}}>
          <div className="pagination pagination--size-md">
            <div className="pagination_container"><a className="pagination_item pagination_item--current">1</a><a className="pagination_item">2</a><a className="pagination_item">3</a><a className="pagination_item">4</a><a className="pagination_item">5</a><a className="pagination_item">6</a><a className="pagination_item">7</a><a className="pagination_item pagination_item--disabled">...</a><a className="pagination_item">16</a></div>
          </div>
        </div>
        <br/>
      </FormGroup>

    </FormGroup>
  );
}













export function PAusersSubsPop({ title, handleModal, index }) {
  const [tab, setTab] = useState("email");

  return (
    <PAmodal
      appearance="lg"
      header="User details"
      footer={false}
      handleModal={handleModal}
    >
      <FormGroup indentation="xs">
        <CardNew wave={false}>
          <CssPopGrid className="">
            <FormGroup label="Status" indentation="xs">
              <CssSelectItems>
                <CssSelectStatus>
                  <StatusDot status="enabled"></StatusDot>
                </CssSelectStatus>{" "}
                Active
              </CssSelectItems>
            </FormGroup>

            <FormGroup label="User Email" indentation="xs">
              {users[index]["email"]}
            </FormGroup>

            <FormGroup label="Last charge" indentation="xs">
              199.99 USD
            </FormGroup>
          </CssPopGrid>
        </CardNew>
      </FormGroup>

      <FormGroup>
        <PAtabs
          // appearance="secondary"
          active="email"
          handleTab={nw => {
            setTab(nw);
          }}
          items={[
            { name: "User email", stateName: "email" },
            { name: "Next invoice date", stateName: "date" },
            { name: "Transactions", stateName: "trans" }
            // {name: 'Actions',
            // stateName: 'action'},
          ]}
          // extra='123'
        />
      </FormGroup>

      {/* {tab === 'email' &&  */}
      <FormGroup>
        <PAh2 tag="h4" title="Change email" />

        <FormGroup>
          <FormGroup label="Old user email">
            <Input
              disabled={true}
              input={{
                value: users[index]["email"]
              }}
            />
          </FormGroup>
          <FormGroup label="New user email">
            <Input
              placeholder="newmail@mail.com"
              input={{
                value: null
              }}
            />
          </FormGroup>
          <FormFooter ignoreCentered={true}>
            <Button appearance="secondary" disabled={true}>
              Save
            </Button>
          </FormFooter>
        </FormGroup>
      </FormGroup>
      {/* } */}

      {/* {tab === 'date' &&  */}
      <FormGroup>
        <PAh2 tag="h4" title="Change renewal date" />
        <FormGroup>
          <FormGroup label="Old user email">
            <Input
              disabled={true}
              input={{
                value: "May 3, 2020"
              }}
            />
          </FormGroup>
          <FormGroup label="New user email">
            <DatePickerInput
              name="single"
              input={{
                // value: this.state.single,
                onChange: () => {
                  void 0;
                }
              }}
              size="sm"
              pickTime={true}
            />
          </FormGroup>
          <FormFooter ignoreCentered={true}>
            <Button appearance="secondary" disabled={true}>
              Save changes
            </Button>
          </FormFooter>
        </FormGroup>
      </FormGroup>
      {/* } */}

      {/* {tab === 'trans' &&  */}
      <FormGroup>
        <PAh2 tag="h4" title="Related transactions" />
        <FormGroup>
          <CssLineHover>
            <CssTh cols="">
              <div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
                <div className="xsui-status-dot xsui-status-dot--active">
                  <div className="xsui-status-dot__icon" />
                  <div className="xsui-status-dot__entry" />
                </div>
                482748117
              </div>
              <div>09/30/2019 1:30 PM</div>
              <div>ID 22877</div>
              <div>EUR&nbsp;59.99</div>
              <div className="transaction-registry-list__cell--extra">
                Credit/Debit Cards (EUR)
              </div>
            </CssTh>
          </CssLineHover>

          <CssLineHover>
            <CssTh>
              <div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
                <div className="xsui-status-dot xsui-status-dot--active">
                  <div className="xsui-status-dot__icon" />
                  <div className="xsui-status-dot__entry" />
                </div>
                482748117
              </div>
              <div>09/30/2019 1:30 PM</div>
              <div>ID 22877</div>
              <div>EUR&nbsp;59.99</div>
              <div className="transaction-registry-list__cell--extra">
                Credit/Debit Cards (EUR)
              </div>
            </CssTh>
          </CssLineHover>

          <CssLineHover>
            <CssTh>
              <div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
                <div className="xsui-status-dot xsui-status-dot--active">
                  <div className="xsui-status-dot__icon" />
                  <div className="xsui-status-dot__entry" />
                </div>
                482748117
              </div>
              <div>09/30/2019 1:30 PM</div>
              <div>ID 22877</div>
              <div>EUR&nbsp;59.99</div>
              <div className="transaction-registry-list__cell--extra">
                Credit/Debit Cards (EUR)
              </div>
            </CssTh>
          </CssLineHover>
        </FormGroup>
      </FormGroup>
      {/* } */}
    </PAmodal>
  );
}

const CssPopGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 220px);
`;


















export const PAtableFilter = ({}) => {
  return (
    <FormGroup indentation="xs">
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat( auto-fill, minmax(160px, 200px) )",
          gridColumnGap: 16,
          marginBottom: 24
        }}
      >
        <FormGroup label="Project">

          <Select
            // align="right"
            name=""
            size="sm"
            options={[
              { label: "All projects", value: 0 },
              { label: "Project 1", extraLabel: 'ID: 9123', value: 1 },
              { label: "Project 2", extraLabel: 'ID: 1414', value: 2 }
            ]}
            input={{
              name: "widgTheme",
              value: 0,
              onChange: () => {
                void 0;
              }
            }}
          />

        </FormGroup>


        <FormGroup label="Subscription plan">
          <Select
            // align="right"
            name=""
            size="sm"
            searchable={true}
            options={[
              {
                label: 'All plans',
                value: 0,
              },
              {
                label: 'Backer',
                extraLabel: '$1.99',
                value: 1,
              },
              {
                label: 'Gods Favor',
                extraLabel: '$19.99',
                value: 2,
              },
              {
                label: 'Ultimate premium',
                extraLabel: '$29.99',
                value: 3,
              },
            ]}
            input={{
              name: "widgTheme",
              value: 0,
              onChange: () => {
                void 0;
              }
            }}
          />
        </FormGroup>


        <FormGroup label="Search">
          <Input
            key="1"
            size="sm"
            offset="left"
            icon="search"
            placeholder="Username or email"
            input={{
              name: "1"
              // onFocus: handleFocus,
              // onChange: e => {
              //   let val = e.target.value;
              //   setInp(val);
              // }
            }}
          />
        </FormGroup>

        <FormGroup label="Subsctiption status">
          <Select
            // disabled={this.disabled}
            name=""
            size="sm"
            options={[
              {
                label: "All statuses",
                value: "all",
                iconAlign: 'right',
              },
              {
                label: <StatusDot status="enabled">Active</StatusDot>,
                customIcon: <CssCounter>12.023</CssCounter>,
                iconAlign: 'right',
                value: "active",
              },
              {
                label: <StatusDot status="disabled">Canceled</StatusDot>,
                value: "canceled",
                customIcon: <CssCounter>3</CssCounter>,
                iconAlign: 'right',
              },
              {
                label: <StatusDot status="testing">Non renewing</StatusDot>,
                value: "renewing",
                customIcon: <CssCounter>12</CssCounter>,
                iconAlign: 'right',
              },
              {
                label: <StatusDot status="processing-outline">In trial</StatusDot>,
                value: "trial",
                customIcon: <CssCounter>20.021</CssCounter>,
                iconAlign: 'right',
              },
              {
                label: <StatusDot status="error">Expired</StatusDot>,
                value: "expired",
                customIcon: <CssCounter>354</CssCounter>,
                iconAlign: 'right',
              }
            ]}
            // searchable={this.searchable}
            // autosize={this.autosize}
            // size={this.size}
            input={{
              value: "all",
              onChange: () => {
                void 0;
              }
            }}
          />
        </FormGroup>

        <FormGroup label="Period">
          <div style={{ position: "relative", display: "inline-block" }}>
            <div style={{ display: "inline-block" }}>
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  display: "inline-block"
                }}
              >
                <button
                  name="period"
                  value="9/1/2019 — 9/30/2019"
                  placeholder="Select dates"
                  className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-left-separated xsui-input--read-only"
                  type="button"
                  data-id="period"
                  data-value="9/1/2019 — 9/30/2019"
                >
                  9/1/2019 — 9/30/2019
                </button>
                <div className="xsui-input__icon">
                  <i
                    className="xsui-icon xsui-icon-calendar"
                    style={{ fontSize: 24, color: "inherit" }}
                  />
                </div>
              </div>
              <div />
            </div>
            <div />
          </div>
        </FormGroup>

      </div>
    </FormGroup>
  );
};





const CssSelectItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
  margin: 0px 0 0 0px;
`;

